import { useParams } from 'react-router-dom';
import FileManager from '../components/FileManager';

function CapCycle() {
  const params = useParams();
  const cycleId = params.cycleId;  
  const folderId = "cap-" + cycleId;
  const folderName = cycleId + ". cyklus";

  return <>
    <FileManager folderId={folderId} folderName={folderName} />
  </>
}

export default CapCycle;